// src/config.js
//
// Central place for the SheetDB endpoint + URL helpers.
// Update API_BASE here if the sheet ever moves — every other file imports from this.
//
// NOTE: this project assumes America/Chicago for all date math.
// See specialDates.js for cutoff / special weekend rules.

export const API_BASE = 'https://sheetdb.io/api/v1/cvjrpaq4erdk1';

// Common endpoint builders
export const sheetUrl = (sheet) =>
  `${API_BASE}?sheet=${encodeURIComponent(sheet)}`;

export const byIdUrl = (sheet, id) =>
  `${API_BASE}/id/${encodeURIComponent(id)}?sheet=${encodeURIComponent(sheet)}`;

export const byColumnUrl = (sheet, col, value) =>
  `${API_BASE}/${encodeURIComponent(col)}/${encodeURIComponent(
    value
  )}?sheet=${encodeURIComponent(sheet)}`;

export const searchUrl = (sheet, paramsObj) => {
  const qs = Object.entries(paramsObj)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return `${API_BASE}/search?${qs}&sheet=${encodeURIComponent(sheet)}`;
};

// Central Time today (yyyy-mm-dd). Exported here so every screen agrees.
export const cstFmtYMD = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Chicago',
});
export const todayCST = () => cstFmtYMD.format(new Date());

// ---- Sheet names (centralized so a sheet rename only happens here) ----
export const ALLERGY_PROFILES_SHEET = 'AllergyProfiles';
export const OUTGOING_EMAILS_SHEET = 'OutgoingEmails';
export const MEMBERS_SHEET = 'Members';
export const BOOKINGS_SHEET = 'Sheet1';

// ---- Email routing ----
// The chef's address is hardcoded for now. When we add admin email control
// (secondary), move this to a Config sheet and read it at runtime.
//
// In-app "Send to chef now" recipients. Matches the recipient list used by
// the daily chef email Apps Script. Comma-separated values are split into
// multiple addresses by the SMTP2GO sender.
export const CHEF_EMAIL = 'support@sse.ooo, wocchef25@gmail.com';

// ---- Published-sheet CSV URLs (read-only, save API quota) ----
//
// Some info-only screens (e.g. BookingSummary) can read from Google Sheets'
// "Publish to web" CSV instead of hitting the SheetDB API. Saves GETs and
// gets CDN-cached, at the cost of ~5 minutes of staleness.
//
// To enable: in Google Sheets, File → Share → Publish to web → choose the
// Sheet1 tab, format = CSV, click Publish. Paste the URL it generates here.
// Leave empty to keep using the SheetDB API (safe fallback).
export const BOOKINGS_PUBLISHED_CSV_URL =
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vSMsgZdEYeSyksJibsEJi8wUTKAUwoRcPt73h_UKO5qWoLMTxjlJYmjLHR0rYtGoZlKbvufy8ttZqLE/pub?gid=0&single=true&output=csv';
